import { EventsManager, FlowEvents } from "../../../abstracts/events/EventsManager";
import { DDDNormalBetPresentation } from "../normal/DDDNormalBetPresentation";

export class DDDFreespinBetPresentation extends DDDNormalBetPresentation {
    constructor(protected id: string = `DDDFreespinBetPresentation`) {
        super(id);
    }

    protected override onBetStarted(): void {
        EventsManager.trigger(FlowEvents.BET_STARTED);

        const freespinsLeft = this.model.data.freespinsLeft;

        this.flowPresentationTimeline.call(
            () => {
                this.keypad.setZeroBetSpinCounter(freespinsLeft - 1);
            },
            undefined,
            0.4
        );
    }
}
